import classNames from "classnames";
import styled from "styled-components";
import { DateDisplay } from "../../../components";
import { MessagePriorities, ReminderStatuses } from "../../../helpers/constants";
import moment from "moment";
import ProjectEventsTableColumn from "./ProjectEventsTableColumn";
import EventsTableActionColumn from "../../clienteventstable/components/EventsTableActionColumn";

const StyledRow = styled.tr`
    background-color: ${({ isCancelled }) => isCancelled ? '#e9ecef' : 'transparent'};
    opacity: ${({ isCancelled }) => isCancelled ? 0.5 : 1};
    position: relative;
`
const ReminderPriorityCell = ({ value, isInfoOnly }) => {

    if (!value || isInfoOnly) return <span className="py-1 px-2">-</span>

    const className = [{
        'bg-priority-high text-priority-high': value === MessagePriorities.High,
        'bg-priority-medium text-priority-medium': value === MessagePriorities.Medium,
        'bg-priority-low text-priority-low': value === MessagePriorities.Low
    }];

    return <span className={classNames("badge py-1 px-2", className)}>
        {{
            [MessagePriorities.Low]: "Low",
            [MessagePriorities.Medium]: "Medium",
            [MessagePriorities.High]: "High"
        }[value]}
    </span>;
};

const ReminderDeadlineDateCell = ({ deadlineDate }) => {
    if (!deadlineDate) {
        return <span>-</span>
    }

    var date = moment(deadlineDate);
    let format = "DD/MM/YYYY HH:mm ";

    if (date.hours() === 0 && date.minutes() === 0) {
        format = "DD/MM/YYYY";
    }

    return <DateDisplay format={format} utc={false}>{date}</DateDisplay>;
};

const ProjectEventsTableRow = ({ data, setSelectedEvent, setSelectedViewEvent }) => {
    
    const {
       id,
       type,
       deadlineDate,
       description,
       notes,
       project,
       projectId,
       createdBy,
       priority,
       masterAccountId,
       status
    } = data;
    
    return (
        <StyledRow key={id} isCancelled={status === ReminderStatuses.Cancelled}>
            {/* Deadline */}
            <ProjectEventsTableColumn className="text-truncate" width={7.5}>
                <ReminderDeadlineDateCell deadlineDate={deadlineDate} />
            </ProjectEventsTableColumn>
            {/* Type */}
            <ProjectEventsTableColumn className="text-truncate" width={7.5}>
                <span>{type}</span>
            </ProjectEventsTableColumn>
            {/* Description */}
            <ProjectEventsTableColumn className="text-truncate"  width={20}>
                <span>{description}</span>
            </ProjectEventsTableColumn>
            {/* Notes */}
            <ProjectEventsTableColumn className="text-truncate" width={47.5}>
                <span>{notes}</span>
            </ProjectEventsTableColumn>
            {/* Created By */}
            <ProjectEventsTableColumn className="text-truncate" width={10}>
                <span>{createdBy}</span>
            </ProjectEventsTableColumn>
            {/* Priority */}
            <ProjectEventsTableColumn width={6} className="">
                <ReminderPriorityCell value={priority} />
            </ProjectEventsTableColumn>
            {/* Action */}
            <EventsTableActionColumn data={data} setSelectedEvent={setSelectedEvent} setSelectedViewEvent={setSelectedViewEvent} />
        </StyledRow>
    );
}

export default ProjectEventsTableRow;